import type { SVGProps } from "react";
const SenecPictogramRfidCard = (props: Pick<SVGProps<SVGSVGElement>, "color">) => (
    <svg width={48} height={48} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
        <path d="M6 19V18C6 10.268 12.268 4 20 4H21V6L20 6C13.3726 6 8 11.3726 8 18V19H6Z" fill="currentColor" />
        <path d="M10 19V18C10 12.4772 14.4772 8 20 8H21V10H20C15.5817 10 12 13.5817 12 18V19H10Z" fill="currentColor" />
        <path
            d="M13.9922 18.0005V19.0005H15.9922V18.0005C15.9922 15.7913 17.783 14.0005 19.9922 14.0005H20.9922V12.0005H19.9922C16.6785 12.0005 13.9922 14.6868 13.9922 18.0005Z"
            fill="currentColor"
        />
        <path
            d="M18 19C18 17.3431 19.3431 16 21 16H34C35.6569 16 37 17.3431 37 19V41C37 42.6569 35.6569 44 34 44H21C19.3431 44 18 42.6569 18 41V40C18 39.4477 18.4477 39 19 39C19.5523 39 20 39.4477 20 40V41C20 41.5523 20.4477 42 21 42H34C34.5523 42 35 41.5523 35 41V19C35 18.4477 34.5523 18 34 18H21C20.4477 18 20 18.4477 20 19V35C20 35.5523 19.5523 36 19 36C18.4477 36 18 35.5523 18 35V19Z"
            fill="currentColor"
        />
        <path fillRule="evenodd" clipRule="evenodd" d="M27 20V26H33V20H27ZM29 24V22H31V24H29Z" fill="currentColor" />
    </svg>
);
export default SenecPictogramRfidCard;
